// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"2e67a9f1","439":"86045db7","541":"48c5fd77","762":"74bb01a5"}[chunkId] + ".chunk.css";
};